import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import AdminLoginView from '../views/login/AdminLoginView.vue';
import AdminHomeView from '../views/AdminHomeView.vue'; // 导入主布局组件


const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: '/admin/login',
    name: 'admin-login',
    component: AdminLoginView
  },
  {
    path: '/admin',
    name: 'admin-home',
    component: AdminHomeView, // 使用AdminHomeView作为父布局
    redirect: '/admin/dashboard', // 重定向到仪表板
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: () => import('../views/dashboard/DashboardView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'content/post',
        name: 'PostManagement',
        component: () => import('@/admin/views/content/post/PostManagementView.vue'),
        meta: { title: '帖子管理', requiresAuth: true }
      },
      {
        path: 'content/comment',
        name: 'CommentManagement',
        component: () => import('@/admin/views/content/comment/CommentManagementView.vue'),
        meta: { title: '评论管理', requiresAuth: true }
      },
      {
        path: 'system/announcement',
        name: 'AnnouncementManagement',
        component: () => import('@/admin/views/system/announcement/AnnouncementManagementView.vue'),
        meta: { title: '公告管理', requiresAuth: true }
      },
      {
        path: 'system/monitor',
        name: 'SystemMonitor',
        component: () => import('@/admin/views/system/monitor/SystemMonitorView.vue'),
        meta: { title: '系统监控', requiresAuth: true }
      }
    ]
  }

];

export default adminRoutes;